import { motion } from 'framer-motion';

const TestimonialsSection = () => {
  const testimonials = [
    {
      id: 1,
      name: '仲井 美和',
      title: '代表取締役',
      company: '関西ビジネスサテライト',
      image: 'https://static.readdy.ai/image/d7a11723d8aa082f15ef10141684e0c1/127d7ef9c2e9720f90b5b1713d70cfca.png',
      quote: '毎月の面談で、売上や経費の推移を分析し、改善点を明確にしてくださるようになりました。特に、無駄な経費を削減し、利益率を向上させるための具体的なアドバイスが非常に役立ちました。',
      link: '/testimonials/interview/nakai-miwa'
    },
    {
      id: 2,
      name: '岡田 学',
      title: '代表取締役',
      company: '株式会社イビリス',
      image: 'https://static.readdy.ai/image/d7a11723d8aa082f15ef10141684e0c1/2f9f9198753682b69ba4c9262eb11081.png',
      quote: '赤石さんと対面できっちりと話合って自分の頭の整理が出来るところ、それとまぁ、プライベートのことも普通に相談出来て、家の購入のこと、こうしたらいいよとか、そういうアドバイスも、税金以外のことでも相談出来るところ。',
      link: '/testimonials/interview/okada-manabu'
    },
    {
      id: 3,
      name: '井上様',
      title: '代表',
      company: '株式会社フラブ',
      image: 'https://static.readdy.ai/image/d7a11723d8aa082f15ef10141684e0c1/35b8762a66e1873ce7fb0f80abf5f547.png',
      quote: 'もうほんとに困ってたので、ほんとに困ってることを、私が思ってる以上の、１００％以上の２００％３００％の回答が一瞬でバンてきたのが衝撃でしたね。',
      link: '/testimonials/interview/inoue'
    }
  ];

  return (
    <section className="py-16 md:py-24 bg-gradient-to-br from-red/5 via-white to-red-light/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12 md:mb-16"
        >
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 md:mb-6">
            お客様の声
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto px-4">
            実際にご利用いただいているお客様からの声をご紹介します
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.a
              key={testimonial.id}
              href={testimonial.link}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="group bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all cursor-pointer"
            >
              <div className="relative overflow-hidden">
                <div className="w-full" style={{ aspectRatio: '1920/1080' }}>
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
              </div>

              <div className="p-6 md:p-8">
                <div className="mb-4 md:mb-6">
                  <h3 className="text-lg md:text-xl font-bold text-red mb-2">
                    {testimonial.company}
                  </h3>
                  <p className="text-sm text-gray-600 mb-1">{testimonial.title}</p>
                  <p className="text-base md:text-lg font-medium text-gray-900">
                    {testimonial.name}
                  </p>
                </div>

                <p className="text-sm md:text-base text-gray-700 leading-relaxed line-clamp-4">
                  {testimonial.quote}
                </p>

                <div className="mt-4 md:mt-6 flex items-center gap-2 text-red font-medium group-hover:gap-3 transition-all text-sm md:text-base">
                  <span>詳しく見る</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </motion.a>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mt-12 md:mt-16"
        >
          <a
            href="/testimonials"
            className="inline-flex items-center gap-2 bg-red text-white px-8 md:px-12 py-3 md:py-4 rounded-full text-sm md:text-[15px] font-medium hover:bg-red-dark transition-all hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg"
          >
            <span>お客様の声をもっと見る</span>
            <i className="ri-arrow-right-line"></i>
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
